import {
  API_STATUS,
  API_STATUS_MASTER,
  API_STATUS_MASTER_DATA,
  GET_BATCH_DATA,
  GET_VALI_DATA,
  IS_SIGNATURE_UPLOADED_STATUS,
  PDF_AND_PAGE_DETAILS,
  UPDATE_FILTER,
  VALIDATE_USER_STATUS,
} from "./types";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case API_STATUS_MASTER:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case GET_BATCH_DATA:
      return {
        ...state,
        batchDetails: action.payload,
      };

    case API_STATUS_MASTER_DATA:
      return {
        ...state,
        apiStatusData: action.payload,
      };

    case UPDATE_FILTER:
      return {
        ...state,
        type: action.payload,
      };

    case API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case PDF_AND_PAGE_DETAILS: {
      return {
        ...state,
        pdfAndPageDetails: action.payload.data,
      };
    }
    case GET_VALI_DATA:
      return {
        ...state,
        coorData: action.payload,
      };

    case IS_SIGNATURE_UPLOADED_STATUS:
      return {
        ...state,
        signUploaded: action.payload,
      };

    case VALIDATE_USER_STATUS:
      return {
        ...state,
        validateUser: action.payload,
      };

    default: {
      return {
        ...state,
      };
    }
  }
};
export default reducer;
